import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState, useEffect } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import CertificationForm from './form';
import Accountholder from './accountholder';
import { useFormikContext } from 'formik';
import { CertificationFormVM } from 'civil-status/view-models/document-birth-form';

const AccordionCertificationComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<CertificationFormVM>();

  useEffect(() => {
    setOpen(!formContext.values.flagInternal || false);
  }, [formContext.values.flagInternal]);

  return (
    <>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls={`panel-register-office-Generalità intestatario-content`}
          id={`panel-register-office-Generalità intestatario-header`}
          expandIcon={<ExpandMore />}
        >
          <Typography>Richiedente</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CertificationForm />
        </AccordionDetails>
      </Accordion>

      <Accountholder />
      <div className="pmi-pt-3 pmi-d-flex pmi-justify-content-center">
        <div className="pmi-pl-2 pmi-w-25 pmi-w-lg-15">
          <PmiButton variant="outlined" color="cdmBrandThird" type="submit">
            Avanti
          </PmiButton>
        </div>
      </div>
    </>
  );
};

AccordionCertificationComponent.displayName = 'Accordion Certification component';

const AccordionCertification = memo(AccordionCertificationComponent);

export default AccordionCertification;
